import { useState,useRef, useEffect } from "react";
import BaseModal from "./basemodal";
import useApi from "../hooks/use-api";
import { Tabs,Tab,Col,Row,Table,Popover,Overlay, Button, Alert} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import { Formik} from 'formik';
import * as Yup from 'yup';
import InputField from "../formik/input-field";
import Checkbox from "../formik/checkbox";
import FloatLabel from "../formik/floating-label";
import InsetAlert from "../components/insetalert";
import useMessageHub from "../hooks/use-messagehub";
import ActionResultText from "../utilities/ActionResultText";
import { useModalStatusContext } from "../contexts/modalstatuscontext";
import MultiCheckbox from "../formik/multicheckbox";
import TestComponent from "../components/testcomponent";
import CardSelect from "../components/cardselect";
import StatusButton from "../components/statusbutton";
import endpointMap from "../utilities/api-endpoints-map";
import api from "../new/axios";

const UserModal = ({modalShown,hideModal,targetID,userChangeCallback}) => {
    const {processing,error,getRequest,postRequest,putRequest} = useApi();
    const childSubmitHandlerRef = useRef(null);
    const [modalLocked,setModalLocked] = useState(false);
    const {registerActivity} = useMessageHub();
    const {isLoading,HasError,handleError} = useModalStatusContext();

    const [userStatus,setUserStatus] = useState("Disabled");

    const mapEndpoints = endpointMap;

    const initialValues = {
        firstName: '',
        lastName : '',
        email : '',
        hIPPADate : '',
        hIPPAUkDate : '',
        corporateCompDate: '',
        roles: []

    }; 

    const validationSchema = Yup.object({
        firstName: Yup.string().required("Required"),
        lastName: Yup.string().required("Required"),
        email: Yup.string().email("Email must be a valid Email Address").required("Required")
    });

    const[user,setUser] = useState(initialValues);

    const getUser = async () => {
        const [data,status] = await getRequest("GetUser",{id: targetID});
        if(status === 200){
            setUserStatus(data.status);
        }
        return [data,status];
    };

    const submitUserRequest = async (values) => {
        const [data, status] =  targetID ? await putRequest("UpdateUser", {...values,id: targetID}) : await postRequest("AddUser",{...values,id: 0});
        return [data,status];
    };

    const handleSubmitFunction = async (values) => {
        if(childSubmitHandlerRef.current){
            await childSubmitHandlerRef.current(values);
        }
    }

    const timeoutRef = useRef(null);
    const [showPopover, setShowPopover] = useState(false);
    const [popovertext,setPopoverText] = useState({heading: '',body : ''});
    const [target, setTarget] = useState(null);

    const popoverHoverEvent = (e,heading,body) =>{
        timeoutRef.current = setTimeout(() => {
            setPopoverText({heading: heading,body: body});
            setShowPopover(true);
            setTarget(e.target);
        }, 1000); 
    }

    const popoverLeaveEvent = () => {
        clearTimeout(timeoutRef.current);
        setShowPopover(false);
    }

    const ActionCompleteCallback = (ActionResult) => {
        registerActivity(
            {
                body: ActionResultText({...ActionResult,objectTarget: 'User'}),
                errorFlag: ActionResult.error
            },
            ActionResult.sessionExpired,
            true
        )
        userChangeCallback();
    }

    const _resendInvite = () => {
        return api.post(mapEndpoints.get('ResendInvite'), {UserID : targetID});
    }

    const _lockUnlockUser = (lock) => {
        return api.patch(mapEndpoints.get('LockUnlockUser'), {UserID : targetID, UserLocked: lock,ts: new Date()})
        .then((response) => {
            setUserStatus(response.data.status);
        })
    }
    
    return(
        <>
            <Overlay
                show={showPopover}
                target={target}
                placement="right"
                containerPadding={20}
                >
                <Popover id="popover-contained">
                    <Popover.Header as="h3">{popovertext.heading}</Popover.Header>
                    <Popover.Body>
                        {popovertext.body}
                    </Popover.Body>
                </Popover>
            </Overlay>
        <Formik
                initialValues={user}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={handleSubmitFunction}
            >
                {
                    formik => 
                    <BaseModal
                    modalShown={modalShown}
                    closeModal={() => hideModal()}
                    ModalTitle={targetID ? <span>Edit User [{user.username}]</span> : <span>Add User</span>}
                    loadData={getUser}
                    submitData={submitUserRequest}
                    objectID={targetID}
                    objectType="User"
                    setData={setUser}
                    error={error}
                    processing={processing}
                    initialValues={initialValues}
                    size="lg"
                    setSubmitHandler={handler => childSubmitHandlerRef.current = handler}
                    formikProps={formik}
                    modalLocked={modalLocked}
                    popoverHover={popoverHoverEvent}
                    popoverLeave={popoverLeaveEvent}
                    setModalLocked={setModalLocked}
                    actionCompleteCallback={ActionCompleteCallback}
            >
             <div>
                                    <Tabs
                                    defaultActiveKey="userinfo"
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                    fill
                                    >
                                    <Tab eventKey="userinfo" title="User Information" disabled={formik.isSubmitting || processing || modalLocked}>
                                        <div className="box box--userinformation">
                                        <Row>
                                    <Col xs={12} md={6}>
                                    <FloatLabel
                                            type="text"
                                            name="firstName"
                                            label="First Name"
                                            placeholder="First Name"
                                            autoComplete="offz"
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                    </Col>
                                    <Col xs={12} md={6}>
                                    <FloatLabel
                                            type="text"
                                            name="lastName"
                                            label="Last Name"
                                            placeholder="Last Name"
                                            autoComplete="offz"
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                    <FloatLabel
                                            type="email"
                                            name="email"
                                            label="Email"
                                            placeholder="Email"
                                            autoComplete="offz"
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                    </Col>
                                </Row>
                                <InputField
                                            type="date"
                                            name="hIPPADate"
                                            label="HIPAA Confidentiality Agreement Date"
                                            max={new Date().toISOString().split('T')[0]}
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                        <InputField
                                            type="date"
                                            name="hIPPAUkDate"
                                            label="HIPAA UK Training Date"
                                            max={new Date().toISOString().split('T')[0]}
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                        {/* <InputField
                                            type="date"
                                            name="webAppTrainingDate"
                                            label="Web App Training Date"
                                            max={new Date().toISOString().split('T')[0]}
                                            disabled={formik.isSubmitting || processing || modalLocked }
                                        /> */}
                                        <InputField
                                            type="date"
                                            name="corporateCompDate"
                                            label="Corporate Compliance Date"
                                            max={new Date().toISOString().split('T')[0]}
                                            disabled={formik.isSubmitting || processing || modalLocked}
                                        />
                                        </div>
                                    </Tab>
                                    <Tab eventKey="roles" title="Roles" disabled={formik.isSubmitting || processing || modalLocked}>
                                        <div className="box box--roles">
                                            <div className="internalbox">
                                                <CardSelect fieldName="roles" objectName="Role" retrieveDataEndpoint="Roles"/>
                                                {/* {
                                                    roles
                                                    ?
                                                        <Table bordered hover responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th>Role Name</th>
                                                                    <th className="text-center"><FontAwesomeIcon icon={faInfoCircle} size="lg" style={{color : "#076bff",cursor: "pointer"}} onMouseEnter={(e) => {popoverHoverEvent(e,"Roles","Assign user roles by toggling the switch for the targeted roles. Hover over roles for more information.")}} onMouseLeave={popoverLeaveEvent}/></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    roles.map((row) => {
                                                                        return(
                                                                            <tr key={row.id}>
                                                                                <td className="textcell" onMouseEnter={(e) => {popoverHoverEvent(e,row.name,row.description)}} onMouseLeave={popoverLeaveEvent}>{row.name}</td>
                                                                                <td className="checkboxcell"><Checkbox type={"switch"} label={row.name} name={"roles"} value={row.id.toString()} disabled={formik.isSubmitting || processing || modalLocked}/> </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    :
                                                        <InsetAlert type="Warn" heading={alertText.roles.heading} body={alertText.roles.body} dismissible={false}/>
                                                } */}
                                            </div>
                                            {/* <MultiCheckbox /> */}
                                            {/* <TestComponent /> */}
                                            {/* <CardSelect fieldName="rolesz" objectName="Role" retrieveDataEndpoint="Roles"/> */}
                                        </div>
                                    </Tab>
                                    </Tabs>
                                    {
                                        targetID !== null
                                        ?
                                            <div>
                                                <div className="d-flex justify-content-end align-items-center mt-1">
                                                    <div className="d-flex">
                                                        {
                                                            userStatus === "Invited" &&
                                                            <StatusButton
                                                                successMessage="Invite Sent!"
                                                                primaryText="Resend Invite" 
                                                                action={() => _resendInvite()}  
                                                                variant='warning' 
                                                            />
                                                        }
                                                        <StatusButton
                                                            refreshFunction={() => userChangeCallback()} 
                                                            className="ms-1" 
                                                            primaryText={userStatus !== "Disabled" ? "Lock User" : "Unlock User"} 
                                                            action={() => _lockUnlockUser(userStatus !== "Disabled" ? true : false)} 
                                                            variant='warning'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        :
                                            null
                                    }
                                    </div>
                        </BaseModal> 
                }
            
            </Formik>
        </>
    )
}


export default UserModal;
